'use strict';

jQuery(document).ready(function ($) {
    ContagemLeituraBlogs();

    function ContagemLeituraBlogs() {
        dataLayer.push({
            'event': 'ga_event',
            'eventCategory': "Categoria",
            'eventAction': "View - Blog",
            'eventLabel': blog_info.context
        });

        gtag('event', 'Categoria', {
            'eventAction': "View - Blog",
            'eventLabel': blog_info.context
        });
    }
});